import Service from '@ember/service';
import { tracked } from 'tracked-built-ins';

export default class ElementRefsService extends Service {
  refs = tracked({});
}
